import { render, staticRenderFns } from "./imageSlider.vue?vue&type=template&id=0c6f2013&scoped=true&"
import script from "./imageSlider.vue?vue&type=script&lang=js&"
export * from "./imageSlider.vue?vue&type=script&lang=js&"
import style0 from "./imageSlider.vue?vue&type=style&index=0&id=0c6f2013&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6f2013",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
installComponents(component, {VCard,VCarousel,VCarouselItem})
